(function () {
    let timeoutId;
  
    window.addEventListener('pageshow', (event) => {
      const isCheckout = window.location.pathname.includes('/checkouts');
      if (isCheckout) return;
  
      const navType = performance.getEntriesByType('navigation')[0]?.type || '';
      const isBackNav = event.persisted || navType === 'back_forward';
  
      if (!isBackNav) return;
  
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
  
        fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
          .then((res) => res.json())
          .then((sections) => {
            if (typeof cartDrawer.renderContentsWithoutOpening === 'function') {
              console.log("Cart RR");
              cartDrawer.renderContentsWithoutOpening({ sections });
            }
          })
          .catch((err) => {
            console.warn('Cart re-render failed:', err);
          });
      }, 100);
    });
  })();
  